"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Label } from "@radix-ui/react-label";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "@/store/store";
import { createProjectFeature, fetchProjects } from "@/features/projects/projectsSlice";
import type { Project } from "@/features/projects/projectsSlice";
import { useAuth } from "@clerk/nextjs";

function CreateProjectDialog() {
  const [projectName, setProjectName] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [projects, setProjects] = useState<Project[] | null>(null); // Start with null

  const dispatch = useDispatch<AppDispatch>();
  const auth = useAuth();
  const pathname = usePathname();

  useEffect(() => {
    const fetchData = async () => {
      const token = await auth.getToken();
      const response = await dispatch(fetchProjects(token));

      if (response.meta.requestStatus === "fulfilled") {
        const fetchedProjects = response.payload as Project[];
        setProjects(fetchedProjects);

        // Only open the dialog if there are no projects
        if (fetchedProjects.length === 0) {
          setIsOpen(true);
        }
      } else {
        console.error("Error fetching projects");
      }
    };

    fetchData();
  }, [dispatch]);

  // Prevent rendering if projects are still being fetched
  if (projects === null) {
    return null;
  }

  // Close the dialog if the pathname is "/"
  if (pathname === "/") {
    return null;
  }

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Project Name:", projectName);
    console.log("Organization Name:", organizationName);

    if (!projectName || !organizationName) {
      alert("Please fill in all fields");
      return;
    }

    // Dispatch an action to create a new project
const token = await auth.getToken();
    const resposne = await dispatch(createProjectFeature({
        project: {
            description: organizationName,
            name: projectName,
        },
        token: token,
        }));

    if (resposne.meta.requestStatus === "fulfilled") {
        console.log("Project created successfully");
        }
    else {
        console.error("Error creating project");
        }
            
    // Reset form fields
    setProjectName("");
    setOrganizationName("");
    setIsOpen(false); // Close the dialog after submission
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Create Project</DialogTitle>
          <DialogDescription>
            Please create a project to get started.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 py-4">
            {/* Project Name Input */}
            <div className="flex flex-col gap-2">
              <Label htmlFor="projectName" className="text-sm font-medium">
                Project Name
              </Label>
              <Input
                id="projectName"
                value={projectName}
                onChange={(e) => setProjectName(e.target.value)}
                placeholder="Enter project name"
                className="w-full"
                required
              />
            </div>

            {/* Organization Name Input */}
            <div className="flex flex-col gap-2">
              <Label htmlFor="organizationName" className="text-sm font-medium">
                Project Description
              </Label>
              <Input
                id="organizationName"
                value={organizationName}
                onChange={(e) => setOrganizationName(e.target.value)}
                placeholder="Enter organization name"
                className="w-full"
                required
              />
            </div>
          </div>
          <DialogFooter>
            <Button type="submit">Create Project</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export { CreateProjectDialog };
